module.exports = __webpack_public_path__ + "static/img/social5-2x.4936b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social5-2x.jpg
// module id = Il22
// module chunks = 0